
const config = {
    collectionIds: {
      fortuneCookieForm: 'fortune-cookie-form',
      contactForm: 'contact-form',
      brochure: 'brochure',
      consultation: 'consultation',
      becomeAPartner: 'become-a-partner',
      integration: 'integration',
      brandcut: 'brandcut',
      podcast: 'podcast',
      aiReadinessForm: 'ai-readiness-form',
      aiReadinessPaymentForm: 'ai-readiness-payment-form',
      academy: 'academy',
      academyBrochure: 'academybrochure',
      academyBookACall: 'academybookacall',
      knowledgenudge:'knowledge-nudge',
    }
  };
  
  export default config;